import { createSlice } from '@reduxjs/toolkit'

export const userPermissionsSlice = createSlice({
  name: 'userPermissions',
  initialState: {
    permissions: [],
    permissionsLoaded: false,
    apiServiceManagement: {
      modify: false,
      view: false,
    },
  },
  reducers: {
    setUserPermissions: (state, { payload }) => {
      state.permissionsLoaded = true;
      if (Array.isArray(payload)) {
        state.permissions = payload;
        return;
      }
      state.permissions = payload?.permissions ?? [];
      if (payload?.apiServiceManagement) {
        state.apiServiceManagement = {
          modify: !!payload.apiServiceManagement.modify,
          view: !!payload.apiServiceManagement.view,
        };
      }
    },
  },
})

export const { setUserPermissions } = userPermissionsSlice.actions
export default userPermissionsSlice.reducer
